<template>
  <!-- 通则 -->
  <div>
    <loading :isShow="loading"></loading>
    <div class="tools-box">
      <div class="left-box">{{ baseInfo.name }}</div>
    </div>
    <Form ref="form" :model="formData" class="my-form" :label-width="200">
      <FormItem prop="timeType" label="计入基本法的基准时间" class="full">
        <RadioGroup v-model="formData.timeType">
          <Radio label="1">承保时间</Radio>
          <Radio label="2">生效日期</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="profit" label="计入基本法利益的产品范围" class="full" :rules="$units.formRule.required('请选择计入基本法利益的产品范围')">
        <div class="box">
          <div class="label">险种类型</div>
          <CheckboxGroup v-model="formData.profitThemeIds" @on-change="checkboxChange">
            <Checkbox v-for="bean in productThemeList" :key="bean.id" :label="bean.id">{{ bean.name }}</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="box">
          <div class="label">长短险标志</div>
          <CheckboxGroup v-model="formData.profitProductType" @on-change="checkboxChange">
            <Checkbox label="1">长险</Checkbox>
            <Checkbox label="2">短险</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="box">
          <div class="label">业务类别</div>
          <CheckboxGroup v-model="formData.profitSellType" @on-change="checkboxChange">
            <Checkbox label="1">网销</Checkbox>
            <Checkbox label="3">经代</Checkbox>
          </CheckboxGroup>
        </div>
      </FormItem>
      <FormItem prop="check" label="计入考核的产品范围" class="full" :rules="$units.formRule.required('请选择计入考核的产品范围')">
        <div class="box">
          <div class="label">险种类型</div>
          <CheckboxGroup v-model="formData.checkThemeIds" @on-change="checkboxChange">
            <Checkbox v-for="bean in productThemeList" :key="bean.id" :label="bean.id">{{ bean.name }}</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="box">
          <div class="label">长短险标志</div>
          <CheckboxGroup v-model="formData.checkProductType" @on-change="checkboxChange">
            <Checkbox label="1">长险</Checkbox>
            <Checkbox label="2">短险</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="box">
          <div class="label">业务类别</div>
          <CheckboxGroup v-model="formData.checkSellType" @on-change="checkboxChange">
            <Checkbox label="1">网销</Checkbox>
            <Checkbox label="3">经代</Checkbox>
          </CheckboxGroup>
        </div>
      </FormItem>
    </Form>
    <div class="tools-box right bottom-box">
      <Button type="primary" @click="$emit('prev')">上一步</Button>
      <Button type="primary" @click="save">下一步</Button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      formData: {},
      baseInfo: {},
      productThemeList: []
    };
  },
  methods: {
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        delete formData.profit;
        delete formData.check;
        this.$http({
          url: '/buz/baseMethod/edit',
          type: 'POST',
          data: formData
        }).then(() => {
          this.$notice.success('保存成功');
          this.$emit('next');
        });
      });
    },
    async init(baseInfo) {
      baseInfo = JSON.parse(JSON.stringify(baseInfo));
      this.baseInfo = baseInfo;
      this.loading = true;
      await this.getProductTheme();
      const allId = this.productThemeList.map(item => item.id);
      this.formData = {
        id: baseInfo.id,
        timeType: baseInfo.timeType || '1',
        profitThemeIds: baseInfo.profitThemeIds ? JSON.parse(baseInfo.profitThemeIds) : [],
        profitProductType: baseInfo.profitProductType ? JSON.parse(baseInfo.profitProductType) : [],
        profitSellType: baseInfo.profitSellType ? JSON.parse(baseInfo.profitSellType) : [],
        checkThemeIds: baseInfo.checkThemeIds ? JSON.parse(baseInfo.checkThemeIds) : [],
        checkProductType: baseInfo.checkProductType ? JSON.parse(baseInfo.checkProductType) : [],
        checkSellType: baseInfo.checkSellType ? JSON.parse(baseInfo.checkSellType) : []
      };
      this.checkboxChange();
      if (!this.formData.profit) {
        this.formData.profitThemeIds = allId;
        this.formData.profitProductType = ['1', '2'];
        this.formData.profitSellType = ['1', '3'];
      }
      if (!this.formData.check) {
        this.formData.checkThemeIds = allId;
        this.formData.checkProductType = ['1', '2'];
        this.formData.checkSellType = ['1', '3'];
      }
      if (!this.formData.profit || !this.formData.check) {
        this.checkboxChange();
      }
      this.loading = false;
    },
    // 选择了选项
    checkboxChange() {
      const profit = [].concat(this.formData.profitThemeIds, this.formData.profitProductType, this.formData.profitSellType);
      this.$set(this.formData, 'profit', profit.join(','));
      const check = [].concat(this.formData.checkThemeIds, this.formData.checkProductType, this.formData.checkSellType);
      this.$set(this.formData, 'check', check.join(','));
    },
    getProductTheme() {
      return this.$http({
        url: '/buz/baseMethod/productTheme/all',
        type: 'GET',
        data: {}
      }).then(res => {
        this.productThemeList = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  &:nth-child(n + 2) {
    margin-top: 10px;
  }
  .label {
    min-width: 100px;
  }
  .ivu-checkbox-wrapper {
    width: 140px;
  }
}
</style>
